<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-KeTing`]" width="1em" height="1em" v-bind="$attrs"><path d="M21.75 18.375H11.625 2.25C1.42157 18.375.75 17.7034.75 16.875V11.25C.75 10.4216 1.42157 9.75 2.25 9.75H3.75C4.57843 9.75 5.25 10.4216 5.25 11.25V13.5C5.25 14.3284 5.92157 15 6.75 15H17.2175C18.046 15 18.7175 14.3284 18.7175 13.5V11.25C18.7175 10.4216 19.3891 9.75 20.2175 9.75H21.75C22.5784 9.75 23.25 10.4216 23.25 11.25V16.875C23.25 17.7034 22.5784 18.375 21.75 18.375zM3 9.75V7.5C3 5.84314 4.34314 4.5 6 4.5H18C19.6568 4.5 21 5.84314 21 7.5V9.75" stroke="#333"/><path d="M12.75 4.5H11.25V15H12.75V4.5zM4.5 18.375H3V19.65C3 19.9814 3.26863 20.25 3.6 20.25H3.9C4.23137 20.25 4.5 19.9814 4.5 19.65V18.375zM21 18.375H19.5V19.65C19.5 19.9814 19.7686 20.25 20.1 20.25H20.4C20.7314 20.25 21 19.9814 21 19.65V18.375z" stroke="#333"/></svg>
</template>
<script>

export default {
  name: 'IconKeTing',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
